import axios from "axios";
import {getAuth} from "../../Services/Security/AuthService";
import {http} from "../../Services/Http/HttpClient";

export const uploadFinanceFile = async (file: File) => {
    let data = new FormData()
    data.append('file', file)

    const fhttp = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            "Content-type": "multipart/form-data;",
            "Authorization": getAuth()
        }
    })

    return fhttp.post(`/admin/finance/import`, data)
}

export const removeFinanceResumeItems = async (month: number, year: number): Promise<unknown> => {
    return await http.delete(`/admin/finance/resume-remove/${month}/${year}`)
}

